export NavigationApp from "./NavigationApp";
export SlideApp from "./SlideApp";
export CalendarApp from "./CalendarApp";
export ModalCalendarApp from "./ModalCalendarApp";
export MenuViewApp from "./MenuViewApp";
export NewsApp from "./NewsApp";



// WEBPACK FOOTER //
// ./src/js/apps/modules/index.js